module.exports = require('./favicon.js')



// WEBPACK FOOTER //
// ./src/plugins/favicon/index.js